<template>
    <div>
        <div class="list-title">
            <h3>Lectura de Correos</h3>
        </div>

        <div class="search-bar">
            <v-container fluid class="pa-0">
                <v-layout row wrap>
                    <v-flex xs12 sm3 md3>
                        <v-menu
                            ref="dateMenu"
                            :close-on-content-click="false"
                            v-model="dateMenu"
                            :nudge-right="40"
                            :return-value.sync="search.date"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px">
                            <v-text-field class="lance"
                                slot="activator"
                                :value="formatDate(search.date)"
                                label="Fecha"
                                append-icon="event"
                                readonly>
                            </v-text-field>
                            <v-date-picker v-model="search.date" no-title scrollable locale="es" :header-date-format="formatCalendarHeader">
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="search.date=null; $refs.dateMenu.save(search.date); searchOnTable();">Cancelar</v-btn>
                                <v-btn flat color="primary" @click="$refs.dateMenu.save(search.date); searchOnTable();">Aceptar</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                        <v-text-field class="lance"
                            v-model="search.source"
                            label="E-mail remitente"
                            @input="searchOnTable">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                        <v-text-field class="lance"
                            v-model="search.subject"
                            label="Asunto"
                            @input="searchOnTable">
                        </v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        <div class="search-bar">
            <v-container fluid class="pa-0">
                <v-layout row wrap>
                    <v-flex xs12 sm3 md3>
                        <v-select class="lance"
                            :items="suppliers"
                            item-text="businessName"
                            v-model="search.supplier"
                            label="Proveedor"
                            @input="searchOnTable"
                            return-object>
                            <v-list-tile v-if="search.supplier" slot="prepend-item" @click="search.supplier = null; searchOnTable();">
                                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                <v-list-tile-title>Limpiar</v-list-tile-title>
                            </v-list-tile>
                            <v-divider v-if="search.supplier" slot="prepend-item" class="mt-2"></v-divider>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                        <v-select class="lance"
                            :items="status"
                            item-text="name"
                            v-model="search.status"
                            label="Estatus"
                            @input="searchOnTable"
                            return-object>
                            <v-list-tile v-if="search.status" slot="prepend-item" @click="search.status = null; searchOnTable();">
                                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                <v-list-tile-title>Limpiar</v-list-tile-title>
                            </v-list-tile>
                            <v-divider v-if="search.status" slot="prepend-item" class="mt-2"></v-divider>
                        </v-select>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
        
        <v-data-table
            :headers="headers"
            :items="list"
            :loading="loading"
            :pagination.sync="pagination"
            class="table-catalog elevation-5">
            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props" @click="goTo('MailConfigurationform/' + props.item.id)">
                <tr>
                    <td class="text-xs-left">{{ formatDate(props.item.date) }}</td>
                    <td class="text-xs-left">{{ props.item.senderEmail }}</td>
                    <td class="text-xs-left">{{ props.item.title }}</td>
                    <td class="text-xs-left">{{ props.item.supplierName }}</td>
                    <td class="text-xs-left">{{ props.item.supplierType }}</td>
                    <td class="text-xs-left">
                        <v-icon v-if="props.item.hasAttachment" color="success">check</v-icon>
                        <v-icon v-else color="red">close</v-icon>
                    </td>
                    <td class="text-xs-left">{{ getStatus(props.item.status) }}</td>
                    <td class="text-xs-left">{{ props.item.filenames }}</td>
                    <td class="justify-center layout px-0">
                        <v-btn fab small color="primary"
                            v-if="credentials.MailConfigurationRead"
                            @click="downloadFiles(props.item.id)"
                            :disabled="!props.item.hasAttachment"><v-icon>save_alt</v-icon></v-btn>
                        <v-btn fab small color="primary" v-if="credentials.MailConfigurationRead" @click="openDetails(props.item)"><v-icon>visibility</v-icon></v-btn>
                    </td>
                </tr>
            </template>
            <template slot="no-data">
                No hay registros para sus parámetros de búsqueda. Favor de intentar otra búsqueda o crear uno nuevo.
            </template>
        </v-data-table>

        <v-dialog v-if="selectedEmail" v-model="showEmailDetail" max-width="750">
            <v-card class="mail-detail pa-5">
                <v-card-title>Detalle de Correo</v-card-title>
                 <div class="search-bar">
                    <v-container fluid class="pa-0">
                        <v-layout row wrap>
                            <v-flex xs12 sm6 md6>
                                <v-text-field class="lance"
                                    v-model="selectedEmail.title"
                                    label="Asunto"
                                    readonly
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                                <v-text-field class="lance"
                                    :value="formatDate(selectedEmail.date) + ' ' + formatTime(selectedEmail.date)"
                                    label="Fecha"
                                    readonly
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                                <v-text-field class="lance"
                                    v-model="selectedEmail.senderEmail"
                                    label="Remitente"
                                    readonly
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                                <v-select class="lance"
                                    v-model="attachmentToDownload"
                                    :items="selectedEmail.emailAttachments"
                                    item-text="filename"
                                    label="Archivos adjuntos"
                                    @input="downloadAttachment(attachmentToDownload)"
                                    return-object>
                                </v-select>
                            </v-flex>
                            <v-flex xs12 class="divider"></v-flex>
                            <v-spacer></v-spacer>
                            <v-flex xs12 sm6 md6>
                                <v-btn color="primary" solo @click="showEmailDetail = false">Cerrar</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>
    import { events, printList } from '../main';
    import _ from 'underscore';
    import moment from 'moment-timezone';
    import * as JSZip from 'jszip';
    import { saveAs } from 'file-saver';

    export default {
        components: { 
        },
        data () {
            return {
                list: [],
                source: [],
                suppliers: [],
                status: [
                    { value: 1, name: 'Por revisar' },
                    { value: 2, name: 'En revisión' },
                ],
                dateMenu: false,
                search: {
                    date: null,
                    source: "",
                    subject: "",
                    supplier: null,
                    status: null,
                },
                headers: [
                    { text: 'Fecha', value: 'date' },
                    { text: 'E-mail remitente', value: 'senderEmail' },
                    { text: 'Asunto', value: 'title' },
                    { text: 'Proveedor', value: 'supplierName' },
                    { text: 'Tipo Proveedor', value: 'supplierType' },
                    { text: 'Archivos', value: 'hasAttachment' },
                    { text: 'Estatus', value: 'status' },
                    { text: 'Nombre', value: 'description' },
                    { text: '', value: 'download', align: 'center', sortable: false },
                ],
                pagination: {
                    sortBy: "",
                    descending: false
                },
                selectedEmail: null,
                showEmailDetail: false,
                attachmentToDownload: null,
                loading: true,
                currentUserId: localStorage.getItem('userId'),
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
            }
        },
        methods: {
            snackbar: function(message) {
                events.$emit('snackbar', message);
            },
            goTo(url) {
                var self = this;
                self.$router.push('/' + url);
            },
            formatCalendarHeader(val) {
                return moment(val).locale("es").format("MMMM YYYY");
            },
            formatDate(date) {
                if(date) {
                    var ndate = moment(date).locale("es").format("DD/MMM/YYYY");
                    var mes = ndate.split("/")[1];
                    var nmes = mes.charAt(0).toUpperCase() + mes.slice(1, -1);
                    return ndate.replace(mes, nmes);
                }
                return '';
            },
            formatTime(date) {
                return date ? moment(date).locale("es").format("HH:mm:ss a") : '';
            },
            getStatus(value) {
                let s = this.status.find(x => x.value == value);
                return s? s.name: "";
            },
            getList: function() {
                return this.$http.get('email')
                    .then(response => {
                        var list = response.body;
                        this.list = list;
                        this.source = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de correos');
                        console.error(error);
                    })
            },
            getSuppliers: function() {
                return this.$http.get('Suppliers')
                    .then(response => {
                        var list = response.body;
                        this.suppliers = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de proveedores');
                        console.error(error);
                    })
            },
            downloadFile(response, filename="attachment") {
                let blob = new Blob([response.data], { type: response.headers.get('Content-Type') });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            },
            downloadFiles(emailid) {
                this.$http.get("email/getattachments/" + emailid, {responseType: "blob"})
                    .then(response => {
                        let blob = new Blob([response.data], { type: response.headers.get('Content-Type') });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = "attachment";
                        link.click();
                    });
            },
            downloadAttachment(attachment) {
                this.$http.get("email/getattachment/" + attachment.id, {responseType: "blob"})
                    .then(response => this.downloadFile(response, attachment.filename));
            },
            openDetails(email) {
                this.selectedEmail = email;
                this.attachmentToDownload = null;
                this.showEmailDetail = true;
            },
            searchOnTable: function() {
                this.list = this.source.filter( item => {
                    let dateEval = this.search.date ? moment(this.search.date).isSame(item.date, "day") : true;
                    let supplierEval = this.search.supplier ? this.search.supplier.businessName === item.supplierName : true;
                    let statusEval = this.search.status ? this.search.status.value === item.status : true;
                    return dateEval && supplierEval && statusEval
                        && item.senderEmail.toLowerCase().includes(this.search.source.toLowerCase())
                        && item.title.toLowerCase().includes(this.search.subject.toLowerCase());
                });
            },
        },
        mounted() {
            let promises = [ this.getSuppliers(), this.getList() ];
            Promise.all(promises).then(result => {
                this.loading = false;
            });
        },
        filters: {
            moment: function (date) {
                return moment(date).locale("es").format('LL');
            }
        },
    }
</script>

<style scoped>
    .table-catalog {
        padding: 30px;
    }

    .table-catalog >>> table.v-table thead th:not(:first-child):not(:last-child),
    .table-catalog >>> table.v-table tbody td:not(:first-child):not(:last-child) {
        padding-left: 20px;
    }

    .table-catalog >>> table.v-table thead tr th {
        font-size: 14px;
        font-weight: bold;
    }

    .table-catalog >>> table.v-table tbody tr td {
        font-size: 12px;
    }

    .mail-detail {
        background-color: var(--v-appBackground-base);
        border-radius: 20px !important;
    }

    .mail-detail .v-card__title {
        font-family: "Montserrat" , sans-serif;
        font-size: 36px;
        font-weight: bold;
        color: var(--v-textColor-base);
        margin-bottom: 15px;
    }
    .mail-detail button.v-btn {
        height: 50px !important;
        width: 92% !important;
        text-transform: none; 
        border-radius: 100px;
        font-size: 16px;
        margin: 0;
        margin-right: 8px;
    }

    .mail-detail .search-bar .v-input {
        overflow: hidden;
        word-break: break-all;
    }

    .mail-detail .divider {
        height: 0px;
        border-bottom: solid 1px var(--v-textColor-base);
        padding: 0 !important;
        margin: 0 8px;
        margin-top: 25px;
        margin-bottom: 40px;
    }

    .mail-detail .v-select >>> .v-select__selections {
        max-width: calc(100% - 50px);
    }
    .mail-detail .v-select >>> .v-select__selection {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
    }

</style>
